var _rect, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamcamplogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96.5625,
    height: 96.5625,
    rx: 22.5,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_467_3674",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 63,
    height: 63
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_467_3674",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 63,
    height: 63
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2188 17.3438H17.3438V79.2188H79.2188V17.3438Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_467_3674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9394 17.3438L53.5073 27.7363L64.4355 33.6384L69.8677 23.2458L58.9394 17.3438ZM68.2605 52.6859H79.2228V40.1068H68.2605V52.6859ZM53.5073 27.7363C47.5953 39.0469 55.6602 52.6859 68.2605 52.6859V40.1068C64.9937 40.1068 62.9028 36.5707 64.4355 33.6384L53.5073 27.7363Z",
    fill: "#1263BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6253 17.3438L43.0574 27.7363L32.1292 33.6384L26.697 23.2458L37.6253 17.3438ZM28.3042 52.6859H17.3418V40.1068H28.3042V52.6859ZM43.0574 27.7363C48.9694 39.0469 40.9045 52.6859 28.3042 52.6859V40.1068C31.571 40.1068 33.6619 36.5707 32.1292 33.6384L43.0574 27.7363Z",
    fill: "#1263BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5257 79.2193L47.9764 65.3207L37.7962 58.1684L28.3457 72.0671L38.5257 79.2193ZM47.9764 65.3207L57.4269 79.2193L67.6069 72.0671L58.1564 58.1684L47.9764 65.3207ZM47.9764 65.3207C47.9832 65.3104 47.9876 65.3052 47.989 65.3038C47.9902 65.3024 47.9896 65.3032 47.9872 65.3054C47.9848 65.3074 47.9814 65.3102 47.9776 65.3129C47.9738 65.3155 47.97 65.3177 47.9668 65.3193C47.9604 65.3225 47.9578 65.3229 47.9602 65.3223C47.9614 65.3221 47.9634 65.3217 47.9664 65.3213C47.9694 65.3209 47.9728 65.3207 47.9764 65.3207C47.98 65.3207 47.9832 65.3209 47.9862 65.3213C47.9892 65.3217 47.9912 65.3221 47.9924 65.3223C47.9948 65.3229 47.9922 65.3225 47.9858 65.3193C47.9826 65.3177 47.979 65.3155 47.975 65.3129C47.9712 65.3102 47.9678 65.3074 47.9654 65.3054C47.963 65.3032 47.9624 65.3024 47.9636 65.3038C47.965 65.3052 47.9694 65.3104 47.9764 65.3207L58.1564 58.1684C53.2362 50.9328 42.7164 50.9328 37.7962 58.1684L47.9764 65.3207Z",
    fill: "#1263BE"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_467_3674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2812 79.2188C65.3676 79.2188 79.2188 65.3676 79.2188 48.2813C79.2188 31.1949 65.3676 17.3438 48.2812 17.3438C31.1949 17.3438 17.3438 31.1949 17.3438 48.2813C17.3438 65.3676 31.1949 79.2188 48.2812 79.2188Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamcamplogo);
export default __webpack_public_path__ + "static/media/Teamcamp logo.62e2e85e9e92e8863bf3c76615f56e4b.svg";
export { ForwardRef as ReactComponent };